module.exports = __webpack_public_path__ + "static/media/Bcom.7e1606b2.png";